import React from 'react';

interface SeoFAQProps {
  faqAccordion?: any
}

const SeoFAQ: React.FC<SeoFAQProps> = ({ faqAccordion }) => {
  if (!faqAccordion?.[0]?.items?.length) return null;

  console.log('faqAccordion: ', faqAccordion)

  const faqData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqAccordion[0].items.map((item) => ({
      '@type': 'Question',
      name: item.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.content
          .map(block => 
            block.children
              .map(child => child.text)
              .join('')
          )
          .join('\n')
      }
    }))
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(faqData)}
    </script>
  );
};

export default SeoFAQ;